/**
 * 동영상
 */
import { Fragment } from 'react';
import { useLoaderData } from 'react-router-dom';
import Header from '@features/content/Header';
import { apiSearchSlice } from '@features/api/apiSearchSlice';
import { setRequestToSearchParams } from '@utils/index';
import { ALIAS, CUR_NETWORK, FILTER_DATA, NETWORK } from '@constants/index';
import { getLocalData } from '@features/api/apiLocalSlice';
import NoData from '../../components/contents/common/NoData';
import { useOption } from '@hooks/useOption';
import { useAppSelector } from '@hooks/defineRtkTypedHook';
import { selectL10N, setAlias } from '@features/ui/UiSlice';
import NctvArticle from '@components/contents/article/NctvArticle';
import FilterWrap from '@components/contents/common/FilterWrap';
import Paging from '@components/contents/common/Paging';
import type { IContentData, ILoaderData, INctv } from '@type/index';

export const NctvLoader =
  (dispatch, option: IOption) =>
  async ({ request }): Promise<INctv | null> => {
    const searchParams = setRequestToSearchParams(request);

    // alias 변경 - searchParams 변경에 사용됨
    dispatch(setAlias(ALIAS.NCTV));

    if (!searchParams?.keyword) {
      return null;
    }

    return CUR_NETWORK === NETWORK.OPDEV
      ? await getLocalData(ALIAS.NCTV, searchParams)
      : await dispatch(apiSearchSlice?.endpoints?.getNctv?.initiate({ option, params: searchParams }));
  };

interface IFilterComponentProps {
  count: number;
}
const FilterComponent = ({ count }: IFilterComponentProps) => {
  const { serviceAlias } = useOption();
  return (
    <Header totalCount={count}>
      <FilterWrap filterDataObj={serviceAlias ? FILTER_DATA[serviceAlias][ALIAS.VIDEO] : {}} />
    </Header>
  );
};

interface IContentComponentProps {
  data: IContentData<INctv>;
}
const ContentComponent = ({ data }: IContentComponentProps) => {
  const l10n = useAppSelector(selectL10N);

  return (
    <Fragment>
      <div className="search-content">
        <ul className="column column-2">
          {data?.list.map((item, i) => (
            <li key={i} className="search-item">
              <NctvArticle item={item} l10n={l10n!} />
            </li>
          ))}
        </ul>
      </div>
      <Paging endPage={data?.pagination?.endPage} showPage={5} l10n={l10n!} />
    </Fragment>
  );
};

const Nctv = () => {
  const { data, isLoading, isError } = (useLoaderData() as ILoaderData<IContentData<INctv>>) || {};

  console.log('Nctv Data', data);

  return (
    <div className="search-result nctv">
      <FilterComponent count={data?.pagination?.total} />
      {!isError && Array.isArray(data?.list) && data?.list?.length > 0 ? <ContentComponent data={data} /> : <NoData />}
    </div>
  );
};

export default Nctv;
